import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

const AdminProtectedRoute = ({ children }) => {
  const { admin } = useAdminAuth();

  if (admin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-950 text-stone-400 text-sm">
        Checking session…
      </div>
    );
  }

  if (admin === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
